import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import ProductAction from "../stores/actions/ProductAction";
import { RootState } from "../stores";

type FormData = {
  id: number;
  product_id: number;
  product_code: string;
  barcode: string;
  product_size: string;
  product_color: string;
  case_qty: number;
  mrp: number;
  landing_cost: number;
};

function UpdateVariantModel({
  setCatModal,
  catModal,
  getVariantList,
  getVariantData,
}: any) {
  const handleClose = () => setCatModal(false);
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<FormData>();

  const { colorList, variantProductList } = useSelector(
    (state: RootState) => state.product
  );

  useEffect(() => {
    setValue("id", getVariantData.id);
    setValue("product_id", getVariantData.product_id);
    setValue("product_code", getVariantData.product_code);
    setValue("barcode", getVariantData.barcode);
    setValue("product_size", getVariantData.size);
    setValue("product_color", getVariantData.color);
    setValue("case_qty", getVariantData.product_variant_min_qty);
    setValue("mrp", getVariantData.product_variant_mrp);
    setValue("landing_cost", getVariantData.product_variant_landing_cost);
  }, [getVariantData, catModal]);

  const formHandleSubmit = async (data: any) => {
    setLoading(true);
    try {
      const variantData = await dispatch(
        ProductAction.updateProductVariant({
          id: data.id,
          product_id: data.product_id,
          product_code: data.product_code,
          barcode: data.barcode,
          product_size: data.product_size,
          product_color: data.product_color,
          qty: data.case_qty,
          mrp: data.mrp,
          landing_cost: data.landing_cost,
        })
      );

      getVariantList();

      if (variantData.status === false) {
        toast.error(variantData.msg);
        setLoading(false);
      } else {
        setLoading(false);
        reset();
        handleClose();
        getVariantList();
        toast.success(variantData.msg);
      }
    } catch (error) {
      handleClose();
      setLoading(false);
    }
  };

  return (
    <div className="modal" style={{ display: catModal ? "block" : "none" }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form
            className="needs-validation"
            onSubmit={handleSubmit(formHandleSubmit)}
            encType="multipart/form-data">
            <div className="modal-header">
              <h5 className="modal-title">Update Variant</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}></button>
            </div>
            <div className="modal-body">
              <div className="card-body">
                <div className="col">
                  <label className="form-label">
                    Product Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Product Code"
                    {...register("product_code")}
                    required={true}
                  />
                </div>
                <div className="col">
                  <label className="form-label">
                    Barcode <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Barcode"
                    {...register("barcode")}
                    required={true}
                  />
                </div>
                <div className="col">
                  <label className="form-label">
                    Size <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Size"
                    {...register("product_size")}
                    required={true}
                  />
                </div>
                <div className="col">
                  <label className="form-label">
                    Color <span className="text-success">( Optional )</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("product_color")}>
                    <option value="" selected disabled>
                      Select Color
                    </option>
                    {colorList?.map((value: any, index: number) => {
                      return (
                        <option value={value.color} key={index}>
                          {value.color}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="col">
                  <label className="form-label">
                    CASE PACK SIZE QTY
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Qty"
                    {...register("case_qty")}
                    required={true}
                  />
                </div>

                <div className="col">
                  <label className="form-label">
                    MRP <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter MRP"
                    {...register("mrp")}
                    required={true}
                  />
                </div>
                <div className="col">
                  <label className="form-label">
                    Ex Factory Price <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Selling Cost"
                    {...register("landing_cost")}
                    required={true}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
                disabled={loading}
                onClick={handleClose}>
                Close
              </button>
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary px-4">
                {loading ? <i className={"fa fa-spinner fa-spin"}></i> : null}
                Update Variant
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdateVariantModel;
